import MainContainer from './MainContainer';
import useGetMovies from '../../../hooks/useGetMovies';
import { NOW_PLAYING_MOVIES } from '../../../utils/constants';
import SecondaryContainer from './SecondaryContainer';

const Home = () => {
  const { movieList, isLoading, listRef } = useGetMovies(
    NOW_PLAYING_MOVIES.url
  );

  return (
    <div className='ring-slate-900/5 mt-[96px] dark:bg-gray-900 bg-gray-50 pb-10 grow'>
      <MainContainer />
      {movieList.length !== 0 && (
        <SecondaryContainer
          movies={movieList}
          listRef={listRef}
          isLoading={isLoading}
          isHomePage={true}
        />
      )}
    </div>
  );
};

export default Home;
